import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const organization = {
    path: '/organizations',
    component: Layout,
    name: 'organizations',
    redirect: '/organizations/index',
    children: [
      {
        path: '/organizations/index',
        component: () => import('@/views/organization/index'),
        name: 'organizations.index',
        meta: { title: i18n.t(`message.organisations`)}
      },
    ]
  }

export default organization
